import { render } from "./single-device.vue?vue&type=template&id=16a64b62&scoped=true&ts=true"
import script from "./single-device.vue?vue&type=script&lang=ts"
export * from "./single-device.vue?vue&type=script&lang=ts"

import "./single-device.vue?vue&type=style&index=0&id=16a64b62&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a64b62"]])

export default __exports__